import React from "react";
import {
  Button,
  PanelDialog,
  PanelHeading,
  PanelRow,
  PanelSpacer,
  PanelActions,
  BoldText,
} from "@backslashbuild/pp-ui";
import { useCreateRFPSForSchedule } from "./api";
import { publish } from "../../pubSub";
import { useHistory } from "react-router-dom";

function CreateRFPsForSchedule({ id }) {
  const history = useHistory();

  // you have to query to see if there are any currently staged pay runs and then disable the button.
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const createRFPs = useCreateRFPSForSchedule();

  async function handleSubmit() {
    try {
      const response = await createRFPs({ scheduleId: id });

      if (response.isSuccess) {
        publish("notification", "RFPs created");
      } else {
        publish(
          "notification",
          <>
            Unable to create RFPs
            <ul>
              {response.errors.map((error) => (
                <li>{error}</li>
              ))}
            </ul>
          </>
        );
      }
      setDialogOpen(false);
    } catch (e) {
      console.error(e, "error creating RFPs");
      publish("notification", "A network error occured.");
    }
  }

  return (
    <>
      <Button large onClick={() => setDialogOpen(true)}>
        Create RFPs
      </Button>
      <PanelDialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <PanelHeading>Create RFPs</PanelHeading>
        <PanelSpacer large />
        <PanelRow>
          <BoldText>
            RFPs will be created for all matched contractors who have not yet been sent to payroll.
            <br />
            <br />
            <br />
            You can come back later and redo this action if you match more contractors.
          </BoldText>
        </PanelRow>
        <PanelSpacer large />
        <PanelActions>
          <Button variant="secondary" onClick={() => setDialogOpen(false)}>
            No, cancel
          </Button>
          <Button onClick={handleSubmit}>Yes, Create RFPs</Button>
        </PanelActions>
        <PanelSpacer large />
      </PanelDialog>
    </>
  );
}

export default CreateRFPsForSchedule;
